import React from "react";
import { BookOpenIcon } from "lucide-react";
import { volumes } from "../data/content";
export function Volumes() {
  return <section className="border-t border-line bg-panel px-5 py-20" data-id="element-119" data-mp="1lw1vnv2rucn3">
      <div className="mx-auto max-w-5xl" data-id="element-120" data-mp="184ey7rx3ey2q">
        <h2 className="text-center font-display text-4xl uppercase text-cream sm:text-5xl" data-id="element-121" data-mp="185q5i1pqynyl">
          Ce que contient <span className="text-gold" data-id="element-122" data-mp="1c3e3jdmqkwup">le pack</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center font-serif text-xl italic text-mute" data-id="element-123" data-mp="1zw4dxiezr82v">
          6 volumes complémentaires qui couvrent chaque étape de vos cours.
        </p>
        <div className="mt-12 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-124" data-mp="1qv660p1fmgf0">
          {volumes.map((v, i) => <article key={v.title} className="flex gap-5 border-b border-line pb-8" data-id="element-125" data-mp="1vsofcgjd2xnj" data-mpi={i}>
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-gold text-ink" data-id="element-126" data-mp="feok3ivgnw6m">
                <BookOpenIcon className="h-6 w-6" aria-hidden data-id="element-127" data-mp="kfc9y17ye6z9" />
              </div>
              <div data-id="element-128" data-mp="3o7n5myqih9w5">
                <p className="text-xs font-bold tracking-widest text-gold" data-id="element-129" data-mp="3o97y8it9mird">VOLUME {i + 1}</p>
                <h3 className="mt-1 text-xl font-bold text-cream" data-id="element-130" data-mp="3ja54vvmne0z8">{v.title}</h3>
                <p className="mt-2 text-mute" data-id="element-131" data-mp="21ht49wh5fio">{v.desc}</p>
              </div>
            </article>)}
        </div>
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/c21669ff-0451-4e1c-9b07-e8204e066496.jpg" alt="Aperçu des fiches imprimables : tablatures, calendrier et partitions" className="mt-14 w-full rounded-2xl" data-id="element-132" data-mp="3t684atq47lih" />
      </div>
    </section>;
}